<template>
    <div>
        <div class="marginCenter">
            <div class="formTitle fsize24 fweight600 fcolor_black">个人基本信息</div>
            <el-form
                :model="form.applyBasic"
                inline
                label-position="right"
                class="form marginTop30"
                :rules="rules"
                ref="oneForm"
            >
                <div class="flex-sb jiben">
                    <div class="left">
                        <div class="marginBom24 pr">
                            <img :src="form.applyBasic.portrait" alt="" />
                            <span
                                v-if="!form.applyBasic.portrait"
                                class="pa fcolor_red"
                                style="left: 50%; top: 50%; transform: translate(-50%, -50%)"
                                >证件照必传</span
                            >
                        </div>
                        <div class="flex-sb marginBom24">
                            <FileUpload
                                ref="upload"
                                :isShowTip="false"
                                class="avatar-uploader pr marginRt10"
                                @on-success="uploadSuccess"
                                id="1"
                                multiple
                                :before-upload="beforeAvatarUpload"
                                :on-success="uploadSuccess"
                                :fileType="['png', 'jpg', 'jpeg']"
                            >
                                <template #content>
                                    <el-button
                                        slot="trigger"
                                        type="primary"
                                        class="grayBtn"
                                        style="width: 96px; height: 36px"
                                        >上传</el-button
                                    >
                                </template>
                            </FileUpload>
                            <el-button
                                type="primary"
                                class="grayBtn"
                                style="width: 96px; height: 36px"
                                @click="clearFile"
                                >删除</el-button
                            >
                        </div>
                        <div>图片大小不超过5mb，图片 格式为(png、jpg、jpeg）</div>
                        <div>一寸证件照，底色要求红色</div>
                    </div>
                    <div class="">
                        <div class="flex-sb">
                            <div class="middle">
                                <div>
                                    <el-form-item label="姓名：" label-width="200px">
                                        <el-input
                                            disabled
                                            v-model="form.applyBasic.userName"
                                            placeholder="请输入姓名"
                                            style="width: 260px"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item label="出生年月：" label-width="200px">
                                        <el-input
                                            placeholder="请输入"
                                            disabled
                                            :value="
                                                $parent.user.idCard
                                                    ? $parent.user.idCard.slice(6, 10) +
                                                      '.' +
                                                      $parent.user.idCard.slice(10, 12)
                                                    : ''
                                            "
                                            style="width: 150px"
                                        >
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item prop="education" label="最高学历：" label-width="200px">
                                        <el-select
                                            v-model="form.applyBasic.education"
                                            placeholder="请选择"
                                            style="width: 260px"
                                        >
                                            <el-option
                                                v-for="item in dict.type.education"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item prop="nativePlace" label="籍贯：" label-width="200px">
                                        <el-cascader
                                            clearable
                                            v-model="nativePlaceArr"
                                            :options="nativePlaceList"
                                            :props="{ expandTrigger: 'hover', value: 'label' }"
                                            @change="addressChange"
                                            style="width: 260px"
                                        ></el-cascader>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item prop="jobTitle" label="职称：" label-width="200px">
                                        <el-select
                                            v-model="form.applyBasic.jobTitle"
                                            placeholder="请选择"
                                            style="width: 260px"
                                        >
                                            <el-option
                                                v-for="item in dict.type.job_title"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item label="手机号：" label-width="200px">
                                        <el-input
                                            :value="$parent.user.phonenumber"
                                            disabled
                                            placeholder="请输入手机号"
                                            style="width: 260px"
                                        ></el-input>
                                    </el-form-item>
                                </div>

                                <div>
                                    <el-form-item prop="credentialsNo" label="执业资格证号：" label-width="200px">
                                        <el-input
                                            v-model="form.applyBasic.credentialsNo"
                                            minlength="24"
                                            maxlength="27"
                                            placeholder="请输入执业资格证书编号"
                                            style="width: 260px"
                                        ></el-input>
                                        <div class="fcolor_gray">（医师必填 ，24或27位）</div>
                                        <div class="fcolor_gray">（技术人员请填写技师证号码）</div>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item prop="registeredScope" label="注册执业范围：" label-width="200px">
                                        <el-input
                                            v-model="form.applyBasic.registeredScope"
                                            placeholder="请输入注册执业范围"
                                            style="width: 260px"
                                        ></el-input>
                                        <div class="fcolor_gray">（请严格按照执业资格证书填写）</div>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item prop="partnerFlag" label="是否合作单位：" label-width="200px">
                                        <el-select
                                            v-model="form.applyBasic.partnerFlag"
                                            placeholder="请选择"
                                            style="width: 260px"
                                            @change="partnerFlagChange"
                                        >
                                            <el-option label="合作单位" value="1"></el-option>
                                            <el-option label="非合作单位" value="0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item prop="selectionUnit" label="选送工作单位：" label-width="200px">
                                        <el-select
                                            v-if="form.applyBasic.partnerFlag === '1'"
                                            v-model="form.applyBasic.selectionUnit"
                                            filterable
                                            placeholder="请选择单位名称"
                                            style="width: 260px"
                                            @change="partnerUnitChange"
                                        >
                                            <el-option
                                                v-for="item in dict.type.partner_organization"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.label"
                                            ></el-option>
                                        </el-select>
                                        <el-input
                                            v-else
                                            v-model="form.applyBasic.selectionUnit"
                                            :disabled="!form.applyBasic.partnerFlag"
                                            placeholder="请输入单位名称"
                                            style="width: 260px"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="right">
                                <div>
                                    <el-form-item prop="userSex" label="性别：" label-width="200px">
                                        <el-radio-group disabled v-model="$parent.user.sex">
                                            <el-radio
                                                v-for="item in dict.type.sys_user_sex"
                                                :key="item.value"
                                                :label="item.value"
                                                >{{ item.raw.dictLabel }}</el-radio
                                            >
                                        </el-radio-group>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item prop="nation" label="民族：" label-width="200px">
                                        <el-select
                                            v-model="form.applyBasic.nation"
                                            placeholder="请选择"
                                            style="width: 260px"
                                        >
                                            <el-option
                                                v-for="item in dict.type.nation"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item prop="politicalAffiliation" label="政治面貌：" label-width="200px">
                                        <el-select
                                            v-model="form.applyBasic.politicalAffiliation"
                                            placeholder="请选择"
                                            style="width: 260px"
                                        >
                                            <el-option
                                                v-for="item in dict.type.political_affiliation"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item prop="healthStatus" label="健康状况：" label-width="200px">
                                        <el-select
                                            v-model="form.applyBasic.healthStatus"
                                            placeholder="请选择"
                                            style="width: 260px"
                                        >
                                            <el-option
                                                v-for="item in dict.type.health_status"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item prop="post" label="职务：" label-width="200px">
                                        <el-input
                                            v-model="form.applyBasic.post"
                                            placeholder="请输入职务"
                                            style="width: 260px"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item label="身份证号：" label-width="200px">
                                        <el-input
                                            :value="$parent.user.idCard"
                                            disabled
                                            placeholder="请输入身份证号"
                                            style="width: 260px"
                                        ></el-input>
                                    </el-form-item>
                                </div>

                                <div style="margin-bottom: 40px">
                                    <el-form-item prop="practitionerNo" label="执业注册证号：" label-width="200px">
                                        <el-input
                                            v-model="form.applyBasic.practitionerNo"
                                            maxlength="15"
                                            placeholder="请输入执业注册证号"
                                            style="width: 260px"
                                        ></el-input>
                                        <div class="fcolor_gray">（医师必填 ，15位）</div>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item prop="registeredPlace" label="注册执业地点：" label-width="200px">
                                        <el-cascader
                                            v-model="registeredPlace"
                                            :options="provinceAndCityList"
                                            :props="{ expandTrigger: 'hover', value: 'label' }"
                                            @change="registeredPlaceChange"
                                            style="width: 260px"
                                            clearable
                                        ></el-cascader>
                                        <div class="fcolor_gray">（请严格按照执业资格证书填写）</div>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item prop="selectionDept" label="选送工作科室：" label-width="200px">
                                        <el-input
                                            v-model="form.applyBasic.selectionDept"
                                            placeholder="请输入工作科室"
                                            style="width: 260px"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div class="registeredPlace">
                            <el-form-item
                                prop="selectionPlace"
                                label="选送单位地址："
                                label-width="200px"
                                style="width: 100%; display: flex !important"
                            >
                                <el-input
                                    v-model="form.applyBasic.selectionPlace"
                                    placeholder="请按照“xx省xx市xx区xx路xx号”规则填写"
                                    style="flex-grow: 1"
                                >
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-sb">
                            <div class="middle">
                                <div>
                                    <el-form-item
                                        prop="hospitalLevel"
                                        label="选送医院等级："
                                        label-width="200px"
                                        class="flex"
                                    >
                                        <el-select
                                            v-model="form.applyBasic.hospitalLevel"
                                            placeholder="请选择"
                                            style="width: 260px"
                                        >
                                            <el-option
                                                v-for="item in dict.type.hospital_level"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item prop="depositBank" label="开户银行：" label-width="200px">
                                        <el-select
                                            v-model="form.applyBasic.depositBank"
                                            placeholder="请选择"
                                            style="width: 260px"
                                            clearable
                                        >
                                            <el-option
                                                v-for="item in dict.type.deposit_bank"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="right">
                                <div>
                                    <el-form-item
                                        prop="selectionPhone"
                                        label="选送单位医教科电话："
                                        label-width="200px"
                                    >
                                        <el-input
                                            v-model="form.applyBasic.selectionPhone"
                                            placeholder="请输入单位医教科电话"
                                            style="width: 260px"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item prop="bankNo" label="银行卡号：" label-width="200px">
                                        <el-input
                                            v-model="form.applyBasic.bankNo"
                                            placeholder="请输入本人银行卡号"
                                            style="width: 260px"
                                            maxlength="19"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="study flex-sb">
                    <div class="right"></div>
                </div>
                <div class="overflow staging marginBom30">
                    <el-button class="fr blueBtn2 btn300" type="primary" @click="staging">保存此页信息</el-button>
                </div>
                <div class="footer fr">
                    <a class="a backIndex active fcolor_blue2 fsize22" @click="goPage(2)">1</a
                    ><a class="a backIndex fcolor_blue2 fsize22" @click="goPage(3)">2</a
                    ><a class="a backIndex fcolor_blue2 fsize22" @click="goPage(4)">3</a>
                    <a class="a backIndex fcolor_blue2 fsize22" @click="goPage(3)">下一页</a>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
// import nativePlace from "@/views/json/nativePlace.json"
import { getToken } from '@/utils/auth';
import { getApplyStorage, stagingApplyStorage } from '@/utils/api';
import { regionData, provinceAndCityData } from 'element-china-area-data';
export default {
    dicts: [
        'political_affiliation',
        'deposit_bank',
        'job_title',
        'tuberculosis',
        'sys_user_sex',
        'nation',
        'education',
        'health_status',
        'pestilence',
        'hospital_level',
        'partner_organization'
    ],
    data() {
        return {
            form: this.$parent.form,
            headers: {
                Authorization: 'Bearer ' + getToken()
            },
            nativePlaceList: regionData,
            nativePlaceArr: [], //籍贯
            provinceAndCityList: provinceAndCityData,
            registeredPlace: [], //执业地点
            rules: {
                education: { required: true, trigger: 'change', message: '最高学历不能为空' },
                nativePlace: { required: true, trigger: 'change', message: '籍贯不能为空' },
                jobTitle: { required: true, trigger: 'change', message: '职称不能为空' },
                // credentialsNo: [{ required: true, trigger: "blur", message: "执业资格证号不能为空" },{min:24,max:27,trigger: "blur", message: "执业资格证号格式不正确" }],
                // registeredScope: { required: true, trigger: "blur", message: "注册执业范围不能为空" },
                partnerFlag: {
                    required: true,
                    trigger: 'change',
                    message: '请选择是否合作单位'
                },
                selectionUnit: {
                    required: true,
                    trigger: ['blur', 'change'],
                    message: '选送工作单位不能为空'
                },
                hospitalLevel: {
                    required: true,
                    trigger: 'change',
                    message: '选送医院等级不能为空'
                },
                nation: { required: true, trigger: 'change', message: '民族不能为空' },
                politicalAffiliation: {
                    required: true,
                    trigger: 'change',
                    message: '政治面貌不能为空'
                },
                healthStatus: { required: true, trigger: 'change', message: '健康状况不能为空' },
                post: { required: true, trigger: 'blur', message: '职务不能为空' },
                // practitionerNo: [{ required: true, trigger: "blur", message: "执业注册证号不能为空" },{min:15,max:15, trigger: "blur", message: "执业注册证号格式不正确" }],
                // registeredPlace: { required: true, trigger: "change", message: "注册执业地点不能为空" },
                selectionDept: {
                    required: true,
                    trigger: 'blur',
                    message: '选送工作科室不能为空'
                },
                selectionPhone: {
                    required: true,
                    trigger: 'blur',
                    message: '选送单位医教科电话不能为空'
                },
                selectionPlace: {
                    required: true,
                    trigger: 'blur',
                    message: '选送单位地址不能为空'
                }
            }
        };
    },
    created() {
        if (this.form.applyBasic.nativePlace != null) {
            this.nativePlaceArr = this.form.applyBasic.nativePlace.split('-');
        }
        if (this.form.applyBasic.registeredPlace != null) {
            this.registeredPlace = this.form.applyBasic.registeredPlace.split('-');
        }
        this.form.applyBasic.userName = this.$parent.user.userName;
        this.form.applyBasic.userSex = this.$parent.user.sex;
        // 是否合作单位：'1'=合作单位，'0'=非合作单位，''=未选择（后端可能返回数字，统一转为字符串）
        const partnerFlag = this.form.applyBasic.partnerFlag;
        this.$set(
            this.form.applyBasic,
            'partnerFlag',
            partnerFlag === undefined || partnerFlag === null ? '' : String(partnerFlag)
        );
    },
    methods: {
        //
        addressChange(arr) {
            //籍贯省市区名称
            this.form.applyBasic.nativePlace = `${arr.toString().replaceAll(',', '-')}`;
        },
        registeredPlaceChange(arr) {
            //执业地点省市名称
            this.form.applyBasic.registeredPlace = `${arr.toString().replaceAll(',', '-')}`;
        },
        // 切换是否合作单位时清空已填写的单位名称，避免合作/非合作数据互相残留
        partnerFlagChange() {
            this.$set(this.form.applyBasic, 'selectionUnit', '');
        },
        // 选择合作单位后，自动带入该单位地址（字典 partner_organization 的 remark）
        partnerUnitChange(label) {
            const item = this.dict.type.partner_organization.find((d) => d.label === label);
            if (item && item.raw && item.raw.remark) {
                this.$set(this.form.applyBasic, 'selectionPlace', item.raw.remark);
            }
        },
        staging() {
            stagingApplyStorage(this.form).then((res) => {
                if (res.code == 200) {
                    this.$message.success('暂存信息成功');
                }
            });
        },
        // 文件上传前
        beforeAvatarUpload(file) {
            let typeList = ['image/jpeg', 'image/png', 'image/jpg'];
            const isJPG = typeList.includes(file.type);
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG与PNG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        // 上传文件成功时
        uploadSuccess(res, file, list) {
            console.log(res, file, list);
            this.$set(this.form.applyBasic, 'portrait', res.url);
        },
        // 删除图片
        clearFile() {
            // this.$refs.upload.clearFiles();
            this.form.applyBasic.portrait = '';
        },
        // 表单校验并跳转页面
        goPage(page) {
            // 先校验证件照是否已上传
            if (!this.form.applyBasic.portrait) {
                this.$message.error('请上传证件照');
                return;
            }
            this.$refs.oneForm.validate((valid) => {
                if (valid) {
                    this.$parent.active = page;
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep .el-form-item__label {
    font-size: 18px !important;
}

::v-deep .registeredPlace .el-form-item__content {
    flex-grow: 1;
}

.backIndex:hover {
    cursor: pointer;
}

.formTitle {
    margin: 50px 0px 30px 240px;
}

::v-deep.form {
    margin-bottom: 47px;
    overflow: hidden;

    .el-form-item__label {
        color: #333;
        font-size: 22px;
        padding: 0;
    }

    .jiben .left {
        // margin-right: 38px;
        width: 206px;

        & > div:nth-child(1) {
            & > img {
                width: 100%;
                height: 252px;
            }
        }
    }

    .study {
        padding: 0 0 0 240px;
        margin-bottom: 40px;
    }

    .footer {
        .a {
            display: inline-block;
            width: 40px;
            line-height: 36px;
            text-align: center;
            border-radius: 5px;
            height: 40px;
            color: #333;
            border: #999999 solid 2px;
            margin-left: 30px;

            &:hover {
                border-color: #2d53c8;
            }
        }

        & > .a:last-child {
            width: 110px;
        }

        & > .active {
            border-color: #2d53c8;
        }
    }
}
</style>
